/**
 * document Normalizr Schema
 */

import { schema } from 'normalizr';

import documentAttribute from './documentAttribute';
import person from './person';

const document = new schema.Entity('documents', {
    documentAttributes: [documentAttribute],
    people: [person]
});

export default document;
